export default __webpack_public_path__ + "static/icons-9fb5d90caad82f4cc58dcaf12657dce7.svg";